import { render, staticRenderFns } from "./OfficalItem.vue?vue&type=template&id=3ac3a4d6&scoped=true"
import script from "./OfficalItem.vue?vue&type=script&lang=js"
export * from "./OfficalItem.vue?vue&type=script&lang=js"
import style0 from "./OfficalItem.vue?vue&type=style&index=0&id=3ac3a4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3a4d6",
  null
  
)

export default component.exports